import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { motion } from 'framer-motion';

export function HypeScreen() {
  const navigate = useNavigate();
  const { nextStep } = useStore();

  useEffect(() => {
    const timer = setTimeout(() => {
      nextStep();
      navigate('/rating/front');
    }, 1500);

    return () => clearTimeout(timer);
  }, [navigate, nextStep]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black onboarding-screen">
      <motion.h1
        className="text-5xl md:text-7xl font-bold text-white tracking-wider"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: [0.8, 1.1, 1], opacity: 1 }}
        transition={{
          duration: 0.6,
          times: [0, 0.6, 1],
          ease: 'easeOut',
        }}
      >
        LET'S GO
      </motion.h1>
    </div>
  );
}
